<div class="landing">
  <div class="container mb-3">
    <div class="row">
      <div class="col mt-5 mb-5">
        <h2>
          <span class="white">Get Started</span>
          <span class="white-60"> With Short Codes</span>
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="card col-4">
        <div class="card-body">
          <div class="card-img-top">
            <img src="https://www.usshortcodes.com/sites/default/files/2023-06/subtract.svg" alt="choose">
          </div>
          <h3 class="card-title">
            Choose
          </h3>
          <p class="card-text">
            Select a five- or six-digit code or have one randomly generated.
        </div>
      </div>
      <div class="card col-4">
        <div class="card-body">
          <div class="card-img-top">
            <img src="https://www.usshortcodes.com/sites/default/files/2023-06/checked.svg" alt="'checked">
          </div>
          <h3 class="card-title">
            Lease
          </h3>
          <p class="card-text">
            Lease your short code and find a partner to help bring your campaign to life.
        </div>
      </div>
      <div class="card col-4">
        <div class="card-body">
          <div class="card-img-top">
            <img src="https://www.usshortcodes.com/sites/default/files/2023-06/spaceship.svg" alt="launch">
          </div>
          <h3 class="card-title">
            Launch
          </h3>
          <p class="card-text">
            Develop your campaign and submit with your partner. Once approved, launch it. </p>
        </div>
      </div>
    </div>
  </div>
</div>